import Box from '@mui/material/Box';
import type { BoxProps } from '@mui/material/Box';
import type { ReactNode } from 'react';

/** Cardul de bază din design: suprafață albă/închisă, colț rotunjit, umbră difuză. */
export function SurfaceCard({ children, sx, ...rest }: BoxProps & { children: ReactNode }) {
  return (
    <Box
      {...rest}
      sx={[
        (theme) => ({
          backgroundColor: theme.palette.weather.surface,
          borderRadius: `${theme.radii.card}px`,
          boxShadow: theme.softShadows.card,
          padding: 'clamp(20px, 2.6vw, 30px)',
          display: 'flex',
          flexDirection: 'column',
          gap: '18px',
          minWidth: 0,
          transition: 'background-color .5s ease, box-shadow .5s ease',
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {children}
    </Box>
  );
}
